import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { TransfersActions } from './transfers.actions';
import { TransferService } from '../../services/transfer.service';

@Injectable()
export class TransfersEffects {
  private actions$ = inject(Actions);
  private svc = inject(TransferService);

  loadAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TransfersActions.loadTransfers),
      mergeMap(({ personnelId }) => this.svc.getAll(personnelId).pipe(
        map(transfers => TransfersActions.loadTransfersSuccess({ transfers })),
        catchError(err => of(TransfersActions.loadTransfersFailure({ error: err.message })))
      ))
    )
  );

  create$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TransfersActions.createTransfer),
      mergeMap(({ dto }) => this.svc.create(dto).pipe(
        map(transfer => TransfersActions.createTransferSuccess({ transfer })),
        catchError(err => of(TransfersActions.createTransferFailure({ error: err.message })))
      ))
    )
  );

  cashHandoff$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TransfersActions.cashHandoff),
      mergeMap(({ dto }) => this.svc.cashHandoff(dto).pipe(
        map(transfer => TransfersActions.cashHandoffSuccess({ transfer })),
        catchError(err => of(TransfersActions.cashHandoffFailure({ error: err.message })))
      ))
    )
  );
}
